module.exports = __webpack_public_path__ + "img/exit.a986c5a0.svg";